import { saveAs } from 'file-saver';
import React from 'react';
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';

const Index = ({ getFunction, queryString, headers = [], tableName }) => {
    const { i18n } = useTranslation();
    const lang = i18n.language;

    const transformDataForExport = (data) => {
        const dataHeaders = headers.length > 0 ? headers : Object.keys(data[0] || {});

        return data.map(item => {
            const transformedItem = {};

            dataHeaders.forEach(header => {
                if (item.hasOwnProperty(header)) {
                    const value = item[header];
                    if (value && typeof value === 'object' && lang in value) {
                        transformedItem[header.replace(/_/g, ' ')] = value[lang];
                    } else if (Array.isArray(value)) {
                        transformedItem[header.replace(/_/g, ' ')] = value.map(subItem => transformDataForExport([subItem])[0]);
                    } else {
                        transformedItem[header.replace(/_/g, ' ')] = value;
                    }
                }
            });

            return transformedItem;
        });
    };

    const handleExportExcel = async () => {
        const data = await getFunction(queryString);
        const localizedData = transformDataForExport(data);
        const ws = XLSX.utils.json_to_sheet(localizedData);
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString('en-GB').replace(/\//g, '_');

        const dataHeaders = headers.length > 0 ? headers : Object.keys(localizedData[0] || {});
        const columnWidths = dataHeaders.map(header => ({ wch: Math.max(header.length, 15) }));
        ws['!cols'] = columnWidths;

        dataHeaders.forEach((header, index) => {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index });
            if (!ws[cellAddress]) return;

            ws[cellAddress].s = {
                font: { bold: true },
                fill: { fgColor: { rgb: "FFFF00" } },
                alignment: { horizontal: "center", vertical: "center" },
            };
        });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array', cellStyles: true });
        const blob = new Blob([wbout], { type: 'application/octet-stream' });
        saveAs(blob, `${tableName + '-' + formattedDate}.xlsx`);
    };


    return (
        <button
            className="btn btn-light mt-btn export-buttons"
            tabIndex="0"
            aria-controls="example2"
            type="button"
            onClick={handleExportExcel}
        >
            <span>Excel</span>
        </button>
    );
};

export default Index;
